import { IBaseUserProfileResponseBody } from '../../../types/response/IBaseUserProfileResponseBody';

export class BaseUserProfile {
  constructor(
    private readonly _userProfileId: string,
    private readonly _locale: string | undefined,
    private readonly _nickname: string,
    private readonly _description: string | undefined,
    private readonly _pictureUrl: string | undefined,
    private readonly _thumbnailUrl: string | undefined,
    private readonly _isMine: boolean
  ) {}

  get userProfileId(): string {
    return this._userProfileId;
  }

  get locale(): string | undefined {
    return this._locale;
  }

  get nickname(): string {
    return this._nickname;
  }

  get description(): string | undefined {
    return this._description;
  }

  get pictureUrl(): string | undefined {
    return this._pictureUrl;
  }

  get thumbnailUrl(): string | undefined {
    return this._thumbnailUrl;
  }

  get isMine(): boolean {
    return this._isMine;
  }

  static fromResponse(response: IBaseUserProfileResponseBody): BaseUserProfile {
    return new BaseUserProfile(
      response.userProfileId,
      response.locale,
      response.nickname,
      response.description,
      response.pictureUrl,
      response.thumbnailUrl,
      response.isMine
    );
  }
}
